<script>
import TwSelectDropdown from '@/components/generic/tw-select-dropdown.vue'
import TwButton from '@/components/generic/tw-button.vue'

export default {
  name: 'TwTabsNavigation' ,
  components: { TwButton, TwSelectDropdown },
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: String,
      default: null
    },
    idField: {
      type: String,
      default: 'id'
    }
  },
  emits: ['update:modelValue'],
}
</script>

<template>
  <div>
    <nav class="flex gap-8 mb-6 overflow-x-auto" aria-label="Tabs">
      <template v-for="tab in tabs">
        <span v-if="tab[idField] === modelValue" :key="'span-' + tab.name" class="font-medium border-b-2 border-gray-900 whitespace-nowrap py-1">
          {{ tab.name }} <span v-if="tab.badge || tab.badge === 0">({{ tab.badge }})</span>
        </span>
        <tw-button v-else :key="tab.name" variant="link" :aria-current="tab[idField] === modelValue ? 'page' : undefined" class="hover:no-underline text-gray-800 text-base font-normal whitespace-nowrap" @click="$emit('update:modelValue', tab[idField])">
          {{ tab.name }} <span v-if="tab.badge || tab.badge === 0">({{ tab.badge }})</span>
        </tw-button>
      </template>
    </nav>
  </div>
</template>

<style scoped>

</style>
